export const GET_PRE_REGISTRATION_REJECTIONS = "GET_PRE_REGISTRATION_REJECTIONS"
export const GET_PRE_REGISTRATION_REJECTIONS_FAIL = "GET_PRE_REGISTRATION_REJECTIONS_FAIL"
export const GET_PRE_REGISTRATION_REJECTIONS_SUCCESS = "GET_PRE_REGISTRATION_REJECTIONS_SUCCESS"

export const ADD_NEW_PRE_REGISTRATION_REJECTION = "ADD_NEW_PRE_REGISTRATION_REJECTION"
export const ADD_NEW_PRE_REGISTRATION_REJECTION_SUCCESS = "ADD_NEW_PRE_REGISTRATION_REJECTION_SUCCESS"
export const ADD_NEW_PRE_REGISTRATION_REJECTION_FAIL = "ADD_PRE_REGISTRATION_REJECTION_FAIL"

export const UPDATE_PRE_REGISTRATION_REJECTION = "UPDATE_PRE_REGISTRATION_REJECTION"
export const UPDATE_PRE_REGISTRATION_REJECTION_SUCCESS = "UPDATE_PRE_REGISTRATION_REJECTION_SUCCESS"
export const UPDATE_PRE_REGISTRATION_REJECTION_FAIL = "UPDATE_PRE_REGISTRATION_REJECTION_FAIL"

export const DELETE_PRE_REGISTRATION_REJECTION = "DELETE_PRE_REGISTRATION_REJECTION"
export const DELETE_PRE_REGISTRATION_REJECTION_SUCCESS = "DELETE_PRE_REGISTRATION_REJECTION_SUCCESS"
export const DELETE_PRE_REGISTRATION_REJECTION_FAIL = "DELETE_PRE_REGISTRATION_REJECTION_FAIL"





